import React from "react";


const AdmissionImage = () => {
  return (
    <div className="gdlr-core-pbf-column gdlr-core-column-30" id="gdlr-core-column-1">
      <div
        className="gdlr-core-pbf-column-content-margin gdlr-core-js"
        style={{ margin: "-123px 0px 0px 0px", padding: "0px 0px 0px 40px" }}
      >
        <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
          <div className="gdlr-core-pbf-element">
            <div className="gdlr-core-image-item gdlr-core-item-pdlr gdlr-core-center-align">
              <div
                className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle"
                style={{ borderWidth: "0px" }}
              >
                <img src="/images/nursing.png" width="700" height="450" alt="Nursing" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmissionImage;
